import { Sprout, Swords, Shield, Star, Crown, Flame } from "lucide-react";

// Rank tiers based on number of Alpha/Tower bosses defeated (out of 34).
export const RANKS = [
  { key: "debutant", label: "Débutant", min: 0, color: "#94A3B8", icon: Sprout },
  { key: "novice", label: "Novice", min: 1, color: "#22C55E", icon: Swords },
  { key: "chasseur", label: "Chasseur", min: 10, color: "#00CCFF", icon: Shield },
  { key: "veteran", label: "Vétéran", min: 20, color: "#A855F7", icon: Star },
  { key: "maitre", label: "Maître", min: 30, color: "#F59E0B", icon: Flame },
  { key: "legende", label: "Légende", min: 34, color: "#FACC15", icon: Crown },
];

export function getRank(defeated = 0) {
  let rank = RANKS[0];
  for (const r of RANKS) if (defeated >= r.min) rank = r;
  return rank;
}

// Bosses needed to reach the next tier (null if already Légende).
export function nextRank(defeated = 0) {
  return RANKS.find((r) => r.min > defeated) || null;
}
